import stickCommon from 'site/stick.common'
let stickScroll = {
    bgmagicSel: null,
    bgmagicArray: [],
    bgmagicOffset: 150,
    init:function () {
        ////////////////////////////
        var self = this

        $(window).on("scroll",stickScroll.scroll)
        $(window).on( "resize", stickScroll.resize)
        //stickScroll.setHeaderPusher(false)
        $('body').addClass('miniheader-animate')

        //resize - which contains init
        self.resize()



    },//init

    //////////////////////////////////////////////////////////////////////////////////////////
    scroll:function() {
        let docWidth = $(document).width()
        //let docHeight = $(document).height()
        let scrollTop = $(window).scrollTop()

        //mini header
        let headershrink_h = 0
        if (docWidth<1200 || scrollTop>headershrink_h) {
            $('body').addClass('miniheader')
        } else {
            $('body').removeClass('miniheader')
        }
        //stickScroll.setHeaderPusher(true)

        //bgmagic
        stickScroll.bgMagicScroll()
    },
    bgMagicInit:function() {
        stickScroll.bgmagicSel = $('.bgmagic')
        let bgmagicOffset2x = 2*(stickScroll.bgmagicOffset)+'px'

        stickScroll.bgmagicSel.each(function () {
            let obj = $(this)
            stickScroll.bgmagicArray.push(obj)
            obj.css({
                top:-stickScroll.bgmagicOffset+'px',
                height:'calc(100% + ' + bgmagicOffset2x + ')'
            })
        });
        stickScroll.bgMagicScroll()
    },
    bgMagicScroll:function() {
        for (let i=0;i<stickScroll.bgmagicArray.length;i++) {
            let obj = stickScroll.bgmagicArray[i]
            let positionOnScreen = stickCommon.getScrollPercent(obj) - 0.5
            //console.log('positionOnScreen',positionOnScreen)
            positionOnScreen = 2*(stickScroll.bgmagicOffset * positionOnScreen)
            gsap.set(obj, {
                'y': positionOnScreen
            });
        }
    },
    resize:function() {
        let siteMode = stickCommon.scGetSiteMode()
        if (siteMode === "tiny") {
            stickScroll.bgmagicOffset = 75
        } else {
            stickScroll.bgmagicOffset = 150
        }
        stickScroll.bgMagicInit()
        stickScroll.scroll()
    }
}
export default stickScroll